import React from 'react'
import { AiFillGithub, AiFillLinkedin, AiFillInstagram } from 'react-icons/ai'
import { FiArrowUp } from 'react-icons/fi'

const Footer = () => {
  return (
    <footer>
      <div className="footerInner">
        <div className="footerLeft">
          <h2 className="footerLogo">M<span>.</span></h2>
          <p>Building digital experiences with code and creativity.</p>
        </div>

        <div className="footerLinks">
          <h4>Quick Links</h4>
          <a href="#home">Home</a>
          <a href="#work">Projects</a>
          <a href="#timeline">Experience</a>
          <a href="#services">Skills</a>
          <a href="#contact">Contact</a>
        </div>

        <div className="footerSocial">
          <h4>Connect</h4>
          <div className="footerSocialIcons">
            <a href="https://github.com/Manav188" target="_blank" rel="noreferrer"><AiFillGithub /></a>
            <a href="https://linkedin.com/in/" target="_blank" rel="noreferrer"><AiFillLinkedin /></a>
            <a href="https://instagram.com/manav_singh188" target="_blank" rel="noreferrer"><AiFillInstagram /></a>
          </div>
        </div>
      </div>

      <div className="footerBottom">
        <p>© {new Date().getFullYear()} Manav Singh. All rights reserved.</p>
        <a href="#home" className="backToTop">
          <FiArrowUp />
        </a>
      </div>
    </footer>
  )
}

export default Footer